import { createAsyncThunk } from '@reduxjs/toolkit';
import { IThunkApi } from 'shared/common/types/redux';
import { fetchSaveCard } from 'shared/createCard/services/fetchSaveCard';
import { setLink } from 'shared/createCard/slices';
import { ICianCard, ISaveCardFormResponse } from 'shared/createCard/types/cianCard';

export const saveCard = createAsyncThunk<ISaveCardFormResponse, ICianCard, IThunkApi>(
  'card/saveCard',
  async (params, thunkApi) => {
    const { rejectWithValue, extra, dispatch } = thunkApi;

    try {
      const response = await fetchSaveCard(extra, { profile: params });

      dispatch(setLink(response.data.uuid));

      return response;
    } catch (e) {
      extra.logger.error(e);

      return rejectWithValue(e.data);
    }
  },
);
